export enum ServiceTypes {
    SERVICE_RENT = 'rent',
    SERVICE_TRANSPORTATION = 'transportation',
}